import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';
import Select from '@material-ui/core/Select/Select';
import Input from '@material-ui/core/Input/Input';
import { CSVLink } from 'react-csv';
import KobooButton from '../Layout/KobooButton';
import * as routes from '../../constants/routes';
import { getRenters } from '../../store/renters/actions';
import Spinner from '../Layout/Spinner';
import { getSites } from '../../store/sites/actions';
import defaultStyles from '../../constants/stylesDefault';
import Loader from '../Layout/Loader';
import KobooTextField from '../Layout/KobooTextField.jsx';
import withAuthorization from '../../hoc/withAuthorization';
import { postVoucher } from '../../store/vouchers/actions';
import StringService from "../../services/StringService";
import { dispatchInfo } from '../../store/infos/actions';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  }
});

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  sites: [],
  selectedSites: [],
  renter_id: '',
  type: 0,
  value: null,
  percent: null,
  number: 0,
  endDate: StringService.dateTimestampToString(Date.now() / 1000),
  createdVouchers: []
};

const types = ["Usage unique", "Abonnement", "Usage Multiple"];

export class AddVouchersForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  static propTypes = {
    authUser: PropTypes.object,
    classes: PropTypes.object.isRequired,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (
      props.authUser
      && props.roles
      && props.errorSites === null
      && props.errorRenters === null
    ) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
      if (!props.renters && !props.pendingRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites) {
        props.getSites(props.authUser.ma, role);
      }
    }
    return newState;
  }

  vouchersForCSV = () => {
    let datas=[];

    for (let voucher of this.state.createdVouchers) {
      let data= Object();
      data['Code'] = voucher.code;
      data['Type'] = types[voucher.type];
      data['Valeur'] = voucher.value / 100;
      data['Reduction'] = voucher.percent;
      data['Date de fin de validite'] = voucher.end_date ?
        StringService.dateTimestampToString(voucher.end_date) : '';
      datas.push(data);
    }
    return datas;
  };


  onSubmit = (event) => {
    const {
      type,
      value,
      percent,
      endDate,
      renter_id,
      selectedSites,
      number
    } = this.state;
    this.props.postVoucher(
        this.props.authUser.ma,
        {
          number,
          renter_id,
          sites: selectedSites,
          type,
          value: value * 100,
          percent,
          end_date: StringService.dateStringToTimestamp(endDate)
        },
      ).then((vouchers) => {
        if (vouchers) {
          this.props.dispatchInfo('Les '+vouchers.length+' coupons ont bien été créés');
          this.setState(byPropKey('createdVouchers', vouchers));
        }
      });

    event.preventDefault();
  };

  onSelectRenter = (event) => {
    this.setState(byPropKey('renter_id', event.target.value));
    const foundRenter = this.props.renters.find(renter => renter.id === event.target.value);
    this.setState(byPropKey(
      'sites',
      this.props.sites.filter(site => site.renter_info_id === foundRenter.id),
    ));
  };

  onSelectSite = (event) => {
    this.setState(byPropKey('selectedSites', event.target.value));
  };

  render() {
    const {
      renter_id,
      type,
      value,
      percent,
      endDate,
      sites,
      selectedSites,
      number,
      createdVouchers
    } = this.state;

    const { classes, renters, pending } = this.props;
    if (pending) {
      return (<Loader />);
    } else if (renters && renters.length) {
      return (
        <form
          onSubmit={this.onSubmit}
          style={defaultStyles.center}
          className={classes.container}
        >
          <TextField
            id="renter_id"
            type="text"
            select
            label="Loueur"
            className={classes.textField}
            value={renter_id}
            onChange={this.onSelectRenter}
            helperText="Choisissez le loueur"
            margin="normal"
            disabled={createdVouchers.length > 0}
          >
            {renters.map(renter => (
              <MenuItem key={renter.id} value={renter.id}>
                {renter.name}
              </MenuItem>
            ))}
          </TextField>
          <InputLabel htmlFor="select-multiple">Sites</InputLabel>
            <Select
              className={classes.textField}
              multiple
              value={selectedSites}
              onChange={this.onSelectSite}
              input={<Input id="select-multiple" />}
              disabled={createdVouchers.length > 0}
            >
              {sites.map(site => (
                <MenuItem key={site.id} value={site}>
                  {site.name}
                </MenuItem>
              ))}
            </Select>
          <TextField
            id="type"
            type="text"
            select
            label="Type"
            className={classes.textField}
            value={type}
            onChange={event => this.setState(byPropKey('type', event.target.value))}
            helperText="Choisissez le type"
            margin="normal"
            disabled={createdVouchers.length > 0}
          >
            {types.map((type, index) => (
              <MenuItem key={index} value={index}>
                {type}
              </MenuItem>
            ))}
          </TextField>
          {type === 0 &&
          < KobooTextField
            label="Valeur (en euros)"
            id="value"
            type="number"
            onChange={event => this.setState(byPropKey('value', event.target.value))}
            value={value}
            disabled={createdVouchers.length > 0}
          />
          }
          {type !== 0 &&
          < KobooTextField
            label="Réduction (en %)"
            id="percent"
            type="number"
            onChange={event => this.setState(byPropKey('percent', event.target.value))}
            value={percent}
            disabled={createdVouchers.length > 0}
          />
          }
          {type !== 0 &&
          < KobooTextField
            label="Fin de validité"
            id="endDate"
            type="date"
            onChange={event => this.setState(byPropKey('endDate', event.target.value))}
            value={endDate}
            disabled={createdVouchers.length > 0}
          />
          }
          < KobooTextField
            label="Nombre de coupons"
            id="number"
            type="number"
            onChange={event => this.setState(byPropKey('number', event.target.value))}
            value={number}
            disabled={createdVouchers.length > 0}
          />
          {createdVouchers.length === 0 &&
          <KobooButton disabled={this.props.sending} type="submit">
            {this.props.sending ?
              <Spinner style={{
                parent: { margin: '4px auto 0' },
                child: {}
              }}/> : 'Créer'}
          </KobooButton>
          }
          {createdVouchers.length > 0 &&
            <CSVLink
              filename={`coupons-${new Date().getTime()}.csv`}
              data={this.vouchersForCSV()}
            >
              Récupérer au format CSV
            </CSVLink>
          }
        </form>
      );
    }
    return (
      <Typography variant="subtitle1">
        Aucun loueur n'a été créé, veuillez en créer un <Link to={routes.RENTER_ADD}>ici</Link>.
      </Typography>);
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    renters: state.renters.content,
    sites: state.sites.content,
    pending: state.renters.pending || state.sites.pending,
    sending: state.bikes.sending,
    pendingRenters: state.renters.pending,
    pendingSites: state.sites.pending,
    errorSites: state.sites.error,
    errorRenters: state.renters.error,
  };
}

export default compose(
  withAuthorization(authUser => !!authUser),
  withStyles(styles),
  connect(mapStateToProps, { postVoucher, getRenters, getSites, dispatchInfo }),
)(AddVouchersForm);



// WEBPACK FOOTER //
// ./src/components/Voucher/AddVouchersForm.jsx